import React, { useCallback } from "react";
import { useSetAtom } from "jotai";
import { isEmpty } from "lodash";
import { useItems } from "atoms/itemAtom";
import { setRadioButtonsModalAtom } from "atoms/modalAtom/modalAtom";
import { useGetProductsGroup } from "features/ProductsGroup/api";

import { Button } from "components/Button/Button";

export function MoveProductButton() {
  const setMoveModal = useSetAtom(setRadioButtonsModalAtom);
  const { itemsState } = useItems();

  const { data: productGroups } = useGetProductsGroup({ enabled: false });

  const handleClick = useCallback(() => {
    if (itemsState.checkedItems.length === 1 && !isEmpty(productGroups)) {
      setMoveModal("Выберите группу для перемещения", false);
    }
  }, [itemsState, setMoveModal, productGroups]);

  return (
    <Button
      icon="move"
      onClick={handleClick}
      disabled={itemsState.checkedItems.length !== 1}
    >
      Переместить
    </Button>
  );
}
